import React, { useEffect } from 'react'
import { FormActionBar, FormContainer } from 'scenes/Dashboard/components-next/Forms'
import { showDemoteUserDealsWarningModal } from 'scenes/Dashboard/scenes/UsersManager/modals'
import { FormProps } from 'utils-next/forms'

import { Portal } from '@mui/material'

import { UserCommonData } from './UserCommonData.component'
import { useCorporateDataFormStyles } from './CorporateDataForm.styles'
import { UserFormData } from './UserDataForm.data'
import { UserStatus } from '../../../../../../../../entities-next/user'
import { TemporalEntityId } from '../../../../../../../../entities-next/common'
import { UserCreationData } from './UserCreationData.component'

export type UserDataFormContentProps = FormProps<UserFormData> & {
  actionBarRef: React.MutableRefObject<any>
}

export function UserDataFormContent({
  isSubmitting,
  handleSubmit,
  actionBarRef,
  initialValues,
  values,
  setFieldValue,
}: UserDataFormContentProps) {
  const { classes } = useCorporateDataFormStyles()
  useUserDataFormEffects(initialValues, values, setFieldValue)
  return (
    <FormContainer disabled={isSubmitting}>
      {initialValues.id === TemporalEntityId.new ? (
        <UserCreationData className={classes.formSection} />
      ) : (
        <UserCommonData className={classes.formSection} />
      )}
      <Portal container={actionBarRef?.current}>
        <FormActionBar onSubmit={handleSubmit} />
      </Portal>
    </FormContainer>
  )
}

function useUserDataFormEffects(
  { status: initialStatus }: UserFormData,
  { status }: UserFormData,
  setFieldValue: FormProps<UserFormData>['setFieldValue']
) {
  useEffect(() => {
    const showWarning = async () => {
      const shouldContinue = await showDemoteUserDealsWarningModal({ userStatus: status as UserStatus })
      if (!shouldContinue) {
        setFieldValue('status', initialStatus)
      }
    }
    if (initialStatus !== status && (status === UserStatus.onHold || status === UserStatus.churned)) {
      showWarning()
    }
  }, [initialStatus, setFieldValue, status])
}
